// Browser mirror of `src/utils/clientOrigin.js`.
//
// ⚠️ CRA CANNOT IMPORT FROM OUTSIDE `client/src`, so this is a copy — the same
// arrangement `lib/leadDays.js`, `lib/plans.js`, `lib/retainer.js` and
// `lib/indiaStates.js` are in. `tests/clientOrigin.test.js` asserts the two
// files answer identically, because drift here is invisible: the filter offers
// a source the server has never heard of and the list simply comes back empty,
// with nothing erroring anywhere.
//
// ⚠️ THE LABELS ARE MIRRORED, THE QUERY LOGIC IS NOT. `originQuery` builds a
// Mongo filter and belongs to the server alone; the browser only ever names a
// source in a query string. Copying the matcher across would be a second
// definition of who matches what, which is the thing the mirror exists to avoid.

export const CLIENT_SOURCES = [
  'manual',
  'excel_import',
  'tally_parties',
  'tally_companies',
  'unknown',
];

export const SOURCE_LABELS = {
  manual: 'Entered by hand',
  excel_import: 'Spreadsheet import',
  tally_parties: 'Tally — party ledger',
  tally_companies: 'Tally — company scan',
  unknown: 'Unknown',
};

// Kept in step with the server's list of what the purge tool may touch, so the
// UI never offers to remove a selection the server will refuse.
export const IMPORTED_SOURCES = ['excel_import', 'tally_parties', 'tally_companies'];

// Short forms for a table cell, where the full label does not fit and the column
// header already says "Source".
export const SOURCE_SHORT = {
  manual: 'Manual',
  excel_import: 'Excel',
  tally_parties: 'Tally ledger',
  tally_companies: 'Tally company',
  unknown: 'Unknown',
};

/** A client whose `origin` predates the field reads as unknown, never as manual. */
export function sourceOf(client) {
  const s = client?.origin?.source;
  return CLIENT_SOURCES.includes(s) ? s : 'unknown';
}

export function labelFor(source) {
  return SOURCE_LABELS[source] || SOURCE_LABELS.unknown;
}

export function shortLabelFor(source) {
  return SOURCE_SHORT[source] || SOURCE_SHORT.unknown;
}

/** True for a client a bulk purge is allowed to remove. */
export function isImported(client) {
  return IMPORTED_SOURCES.includes(sourceOf(client));
}
